(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (() => {
  let expiryTimer;
  let queued = false;
  const updatePrices = () => {
    queued = false;
    clearTimeout(expiryTimer);
    let nextExpiry = Infinity;
    document.querySelectorAll('[data-muph-price]').forEach((price) => {
      const endsAt = Number(price.dataset.muphEndsAt);
      if (Date.now() >= endsAt) {
        const regular = price.querySelector('template[data-muph-regular-price]');
        if (regular) price.replaceWith(regular.content.cloneNode(true));
      } else {
        nextExpiry = Math.min(nextExpiry, endsAt);
      }
    });
    if (nextExpiry < Infinity) expiryTimer = setTimeout(updatePrices, Math.max(50, nextExpiry - Date.now() + 50));
  };
  const queueUpdate = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(updatePrices);
  };
  new MutationObserver(queueUpdate).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', updatePrices);
  window.addEventListener('pageshow', updatePrices);
  updatePrices();
})();
  } catch(e) { console.error(e); }
})();

})();
